/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

export enum ISOs {
  CAN = 'CAN',
  CHE = 'CHE',
  DEU = 'DEU',
  GBR = 'GBR',
  NZL = 'NZL',
  USA = 'USA',
  ZAF = 'ZAF',
  CA = 'CAN',
  CH = 'CHE',
  DE = 'DEU',
  GB = 'GBR',
  NZ = 'NZL',
  US = 'USA',
  ZA = 'ZAF',
}

export enum RegionToISOs {
  CA = ISOs.CAN,
  CH = ISOs.CHE,
  DE = ISOs.DEU,
  GB = ISOs.GBR,
  NZ = ISOs.NZL,
  US = ISOs.USA,
  ZA = ISOs.ZAF,
}

export enum ISOsToRegions {
  CAN = 'CA',
  CHE = 'CH',
  DEU = 'DE',
  GBR = 'GB',
  NZL = 'NZ',
  USA = 'US',
  ZAF = 'ZA',
}

export enum PaymentISOs {
  CA = 'CA',
  CH = 'CH',
  DE = 'DE',
  GB = 'GB',
  NZ = 'NZ',
  US = 'US',
  ZA = 'ZA',
}

export enum Currencies {
  CAD = 'CAD',
  CHF = 'CHF',
  EUR = 'EUR',
  GBP = 'GBP',
  NZD = 'NZD',
  USD = 'USD',
  ZAR = 'ZAR',
}

export const BILLING_COUNTRIES = {
  [ISOs.CAN]: { countryCode: PaymentISOs.CA, currencyCode: Currencies.CAD },
  [ISOs.CHE]: { countryCode: PaymentISOs.CH, currencyCode: Currencies.CHF },
  [ISOs.DEU]: { countryCode: PaymentISOs.DE, currencyCode: Currencies.EUR },
  [ISOs.GBR]: { countryCode: PaymentISOs.GB, currencyCode: Currencies.GBP },
  [ISOs.NZL]: { countryCode: PaymentISOs.NZ, currencyCode: Currencies.NZD },
  [ISOs.USA]: { countryCode: PaymentISOs.US, currencyCode: Currencies.USD },
  [ISOs.ZAF]: { countryCode: PaymentISOs.ZA, currencyCode: Currencies.ZAR },
};
